import BaseController from '../BaseController';
import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { Inject } from '@odinjs/odin';
import { AnalyticsAPI } from '@philips-internal/oswald-ui-components';
import { AnalyticsAliases, FragmentNames } from '../../codegen';
import ConfigurationService from '../../services/configuration-service';

@Controller({ fragment: FragmentNames.ANALYTICS })
class AnalyticsController extends BaseController {

  @Inject(AnalyticsAliases.ANALYTICS)
    analytics!: AnalyticsAPI;

  @OnMount({ target: AnalyticsAliases.ANALYTICS })
  onMountAnalytics(): void {
    this.analytics.restoreState();
    ConfigurationService.getConfigurationData().then(response => {
      this.analytics.setId(response.analyticsKey);
    });
  }

}

export default AnalyticsController;
